module.exports = __webpack_public_path__ + "static/media/preview_chart_1_Revenue.bf2d23ee.PNG";